<div class="container-fluid pt-4">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center" *ngIf="!societyClose">
          <h5 class="election-title">👩‍💼 Society Auditor Allotment</h5>
          <!-- <button type="button" class="btn btn-info btn-sm" [disabled]="isAllotAuditorDisabled" title="Allot Auditor"
             (click)="openAllotAuditorModal()">
            <i class="fa fa-user"></i> Allot Auditor
          </button> -->
          <button type="button" class="btn btn-info btn-sm" title="Allot Auditor" (click)="openAllotAuditorModal()">
            <i class="fa fa-user"></i> Appoint Auditor
          </button>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="AllotAuditor" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
          aria-labelledby="AllotAuditorLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="AllotAuditorLabel">
                  Appoint Auditor
                </h1>
                <button type="button" class="btn-close" (click)="resetForm()" data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form #auditorForm="ngForm" (ngSubmit)="submitAuditorForm()">
                  <div class="row">
                    <input type="number" class="form-control" name="iAllotAuditorID" id="iAllotAuditorID"
                      [(ngModel)]="formData.iAllotAuditorID" hidden />

                    <!-- Date of AGM -->
                    <!-- <div class="col-lg-6 col-md-6 mb-2">
                    <label for="" class="form-label">Date of AGM <span class="text-danger">*</span></label>
                    <input type="date" [max]="today" (keydown)="false" class="form-control" name="agmDate" id="agmDate"
                      [(ngModel)]="formData.agmDate" required>
                    <div *ngIf="auditorForm.submitted && !formData.agmDate" class="text-danger">Date of AGM is required.
                    </div>
                  </div> -->
                    <div class="col-lg-6 col-md-6 mb-2">

                      <label class="form-label">
                        Date of AGM <span class="text-danger">*</span>
                      </label>


                      <input type="text" class="form-control" placeholder="dd/mm/yyyy"
                        [value]="formData.agmDate ? (formData.agmDate | date:'dd/MM/yyyy') : ''" readonly
                        (click)="openPicker(datePicker)" />


                      <input #datePicker type="date" name="agmDate" [min]="minAgmDate" [max]="today"
                        [(ngModel)]="formData.agmDate" style="position:absolute; opacity:0; pointer-events:none;"
                        required />


                      <div *ngIf="auditorForm.submitted && !formData.agmDate" class="text-danger">
                        Date of AGM is required.
                      </div>

                    </div>

                    <!-- Resolution Number -->
                    <div class="col-lg-6 col-md-6 mb-2">
                      <label for="" class="form-label">
                        Resolution Number <span class="text-danger">*</span>
                      </label>
                      <input type="text" class="form-control" placeholder="Enter Resolution Number" name="resolutionNo"
                        id="resolutionNo" [(ngModel)]="formData.iResolutionNo" minlength="1" maxlength="16" required
                        placeholder="Enter Resolution" (keypress)="validateNumber($event)"
                        (paste)="onPasteNumber($event)" />
                      <div *ngIf="
                          auditorForm.submitted &&
                          (!formData.iResolutionNo ||
                            formData.iResolutionNo < 1)
                        " class="text-danger">
                        Resolution number must be greater than zero.
                      </div>
                    </div>

                    <!-- Minutes of AGM -->
                    <div class="col-lg-6 col-md-6 mb-2">


                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <label for="MinutesofAGM" class="form-label">
                          Minutes of AGM
                          <span class="text-danger">*</span>
                        </label>

                        <a *ngIf="voterListBase64" href="javascript:void(0)"
                          class="text-decoration-none text-primary small fw-semibold d-inline-flex align-items-center"
                          (click)="previewFile(voterListBase64,'IdentityDetails')">
                          <i>View</i>
                        </a>
                      </div>
                      <input type="file" class="form-control" (change)="onFileChange($event)" id="MinutesofAGM"
                        name="sUploadMomAGM" accept=".jpg, .jpeg, .png, .pdf" [(ngModel)]="formData.sUploadMomAGM"
                        required />
                      <div *ngIf="auditorForm.submitted && !formData.sUploadMomAGM" class="text-danger">
                        Please upload the minutes of AGM.
                      </div>
                      <small class="form-text text-muted">
                        types:jpg, jpeg, pdf | Max size: 2 MB
                      </small>
                    </div>
                    <h6 class="election-title"> Appoint Auditor</h6>
                    <!-- Auditor Type -->
                    <!-- Select Auditor Type -->
                    <div class="col-lg-4 col-md-6 mb-2">
                      <label for="auditorType" class="form-label">Auditor Type <span
                          class="text-danger">*</span></label>
                      <select class="form-control" name="auditorType" id="auditorType" [(ngModel)]="formData.iAuditorID"
                        required (change)="DropDownData(formData.iAuditorID)">
                        <option value="0" disabled>Select Auditor</option>
                        <option *ngFor="let auditor of auditors" [value]="auditor.id">
                          {{ auditor.name }}
                        </option>
                      </select>
                      <div *ngIf="auditorForm.submitted && !formData.iAuditorID" class="text-danger">
                        Auditor type is required.
                      </div>
                    </div>

                    <!-- Select Auditor -->

                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="formData.iAuditorID != 17">
                      <label for="auditor" class="form-label">Select Auditor
                        <span class="text-danger">*</span></label>
                      <select class="form-control" name="auditor" id="auditor" [(ngModel)]="formData.iAuditorIDType"
                        required (change)="GetData()">
                        <option value="0" disabled selected>
                          Auditor Name
                        </option>
                        <option *ngFor="let audi of auditorName" [value]="audi.iUserID">
                          {{ audi.name }}
                        </option>
                      </select>
                      <div *ngIf="
                          auditorForm.submitted && !formData.iAuditorIDType
                        " class="text-danger">
                        Please select an auditor.
                      </div>
                    </div>

                    <!-- Auditor Email -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="formData.iAuditorID != 17">
                      <label for="auditorEmail" class="form-label">Auditor Email
                      </label>
                      <input type="email" class="form-control" placeholder="Enter Email Id" name="auditorEmail"
                        [value]="formData.sAuditorEmail" id="auditorEmail" disabled />
                    </div>

                    <!-- Auditor Mobile No -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="formData.iAuditorID != 17">
                      <label for="auditorMobile" class="form-label">Auditor Mobile No.
                      </label>
                      <input type="text" class="form-control" placeholder="Auditor Mobile No." name="auditorMobile"
                        id="auditorMobile" [(ngModel)]="formData.sAuditorMobile" disabled />
                    </div>

                    <!-- Total Audit Conducted -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="!hideDivs">
                      <label for="totalAuditConducted" class="form-label">Previous Total Audit Allotted</label>
                      <input type="number" class="form-control" placeholder="Previous Total Audit Allotted"
                        name="totalAuditConducted" id="totalAuditConducted" [(ngModel)]="formData.totalAuditConducted"
                        disabled />
                    </div>

                    <!-- Total Audit Completed -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="!hideDivs">
                      <label for="totalAuditCompleted" class="form-label">Previous Total Audit Completed</label>
                      <input type="number" class="form-control" placeholder="Previous Total Audit Completed"
                        name="totalCompletedAudit" id="totalCompletedAudit" [(ngModel)]="formData.totalCompletedAudit"
                        disabled />
                    </div>
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="!hideDivs">
                      <label for="currentYearTotalAllotted" class="form-label">Current Year Total Count
                        Completed</label>
                      <input type="number" class="form-control" placeholder="Current Year Total Count Completed"
                        name="currentYearTotalAllotted" id="currentYearTotalAllotted"
                        [(ngModel)]="formData.currentYearTotalAllotted" disabled />
                    </div>

                    <!-- Total Audit Completed -->
                    <div class="col-lg-4 col-md-6 mb-2" *ngIf="!hideDivs">
                      <label for="currentYearTotalCompleted" class="form-label">Current Year Total Allotted</label>
                      <input type="number" class="form-control" placeholder="Current Year Total Allotted"
                        name="currentYearTotalCompleted" id="currentYearTotalCompleted"
                        [(ngModel)]="formData.currentYearTotalCompleted" disabled />
                    </div>
                  </div>

                  <div class="modal-footer">
                    <!-- <button type="submit" class="btn btn-success" data-bs-dismiss="modal"
                    [disabled]="!isFormValid()">Submit</button> -->
                    <button type="submit" class="btn btn-success" [disabled]="!isFormValid() || isSubmitting"
                      data-bs-dismiss="modal">
                      <span *ngIf="!isSubmitting">Submit</span>
                      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                      <span *ngIf="isSubmitting">loading...</span>
                    </button>
                  </div>
                  <div class="modal fade" id="IdentityDetails">
                    <div class="modal-dialog modal-xl modal-dialog-centered">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Preview File</h5>
                          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body text-center">


                          <iframe [src]="base64Pdf" style="width:100%; height:70vh; border:none;">
                          </iframe>


                          <img *ngIf="!voterListBase64?.includes('pdf')" [src]="voterListBase64"
                            style="max-width:100%; max-height:70vh;" />

                        </div>

                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!--end Modal -->
        <div class="card-body">
          <div class="row">
            <!-- Type of Auditor Filter -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filterType" class="form-label">Type of Auditor</label>
              <select class="form-control" name="iAuditorID" id="iAuditorID" [(ngModel)]="filter.iAuditorID" required
                (change)="DropDownData(filter.iAuditorID)" (click)="search()">
                <option value="" selected>Select Auditor</option>
                <option *ngFor="let audit of auditors" [value]="audit.id">
                  {{ audit.name }}
                </option>
              </select>
            </div>

            <!-- Auditor NAme -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filterDistrict" class="form-label">Auditor</label>
              <select class="form-control" name="auditorname" id="auditorname" (change)="search()">
                <option value="" selected disabled>Auditor Name</option>
                <option *ngFor="let audii of auditorName" [value]="audii.name">
                  {{ audii.name }}
                </option>
              </select>
            </div>

            <!-- Keyword Filter -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="keyword" class="form-label">Any Keywords</label>
              <input class="form-control" [(ngModel)]="filter.keyword" (keyup)="search()"
                placeholder="Enter Any Keywords" id="keyword" />
            </div>

            <!-- Search Button -->
            <div class="col-lg-12 mb-3 text-end">
              <button type="button" class="btn btn-primary btn-sm" title="Search" (click)="search()">
                <i class="bi bi-search"></i> Search
              </button>
            </div>

            <div class="col-lg-12">
              <div class="pagination-controls" style="
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  width: 100%;
                ">
                <div class="pagination-right" style="display: flex; align-items: center">
                  <label for="rowsPerPage" style="margin-right: 8px">Display Data:</label>
                  <select id="rowsPerPage" [(ngModel)]="page.pageSize" (change)="onRowsPerPageChange()"
                    style="padding: 5px; font-size: 14px">
                    <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>
              </div>
              <br />

              <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
                [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
                (page)="setPage($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
                [loadingIndicator]="loading">
                <!-- S.No. Column -->
                <ngx-datatable-column name="#" [sortable]="false">
                  <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <span>{{
                      (page.pageNumber - 0) * page.pageSize + rowIndex + 1
                      }}</span>
                  </ng-template>
                </ngx-datatable-column>

                <!-- Dynamic Columns -->
                <ngx-datatable-column *ngFor="let column of columns" [sortable]="true" [name]="column.name"
                  [prop]="column.prop">
                  <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>

                <!-- Action Column -->
                <ngx-datatable-column name="Action" [sortable]="false">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <button type="button" title="Audit Status & History" class="btn btn-info btn-sm"
                      style="margin-bottom: 10px" (click)="
                        auditStatus(row.iSocietyDetailsID, row.iAllotAuditorID)
                      " data-bs-toggle="modal" data-bs-target="#AuditorStatus">
                      <i class="bi bi-clock-history"></i> Audit Status
                    </button>

                    &nbsp;
                    <a href="javascript:void(0)" data-bs-toggle="modal"
                      [style.display]="row.showPaymentDone ? 'none' : 'inline-block'" data-bs-target="#AuditorStatus"
                      title="Payment" class="btn btn-primary btn-sm" style="margin-bottom: 10px;"
                      (click)="setPaidAmount(row)" data-bs-toggle="modal" data-bs-target="#PaymentAuditor">
                      Payment
                    </a>
                    <a href="javascript:void(0)" title="Payment" class="btn btn-primary btn-sm"
                      style="margin-bottom: 10px;" [style.display]="row.isPaymentDone ?  'inline-block' : 'none'"
                      (click)="openDeleteModal(row.iAllotAuditorID)">
                      Payment Done
                    </a>

                    <!-- <button type="button" class="btn btn-danger btn-sm" (click)="openDeleteModal(row.iAllotAuditorID)"
            data-bs-toggle="modal" data-bs-target="#exampleModalCenter" style="margin-bottom: 10px;"  [class.disabled]="row.isDisabled"
            [style.display]="row.isDisabled ?'inline-block' : 'none' ">
            <i class="bi bi-trash3"></i>
          </button> -->
                    <a href="javascript:void(0)" title="Make Payment" class="btn btn-outline-success btn-sm"
                      style="margin-bottom: 10px" [style.display]="
                        row.showPaymentDone ? 'none' : 'inline-block'
                      " (click)="openDeleteModal(row.iAllotAuditorID)">
                      <i class="bi bi-currency-rupee"></i> Fees:
                      {{ row.auditFees }}
                    </a>
                    <!-- <a href="javascript:void(0)" title="Make Payment" class="btn btn-outline-success btn-sm"
            style="margin-bottom: 10px;" [style.display]="row.showPaymentDone ? 'none' : 'inline-block'"
            (click)="openDeleteModal(row.iAllotAuditorID)">
            <i class="bi bi-currency-rupee"></i> Application No.: {{ row.auditApplicationNumber }}
          </a> -->

                    <button type="button" class="btn btn-sm btn-outline-primary align-items-center" [style.display]="
                        row.showPaymentDone ? 'none' : 'inline-block'
                      " (click)="
                        processToViewChecklist(
                          row.iSocietyDetailsID,
                          row.iSocietyTransID
                        )
                      ">
                      <i class="bi bi-eye me-1"></i> View Checklist
                    </button>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Confirmation Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Delete Allot Audit
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete this Audit Allotment?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="confirmDelete()">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Payment Modal -->
  <form #paymentForm="ngForm" (ngSubmit)="onSubmit(paymentForm)" novalidate>
    <div class="modal fade" id="PaymentAuditor" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="PaymentAuditorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title election-title" id="PaymentAuditorLabel">
              Payment Auditor
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="row">
              <input type="hidden" class="form-control" [(ngModel)]="paymentdata.iSocietyDetailsID"
                name="iSocietyDetailsID" />

              <input type="hidden" class="form-control" [(ngModel)]="paymentdata.iSocietyTranID"
                name="iSocietyTranID" />

              <!-- Amount to be Paid -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Amount to be Paid</label>
                <input type="number" class="form-control" placeholder="Amount to be Paid"
                  [(ngModel)]="paymentdata.paidAmount" name="paidAmount" readonly />

              </div>
              <!-- Paid Through -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Paid Through</label>
                <select class="form-control" [(ngModel)]="paymentdata.paidThrough" name="paidThrough" required
                  (change)="onPaidThroughChange()" #paidThrough="ngModel">
                  <option value="">Select Payment Method</option>
                  <option value="UPI">UPI</option>
                  <option value="NEFT">NEFT</option>
                  <option value="RTGS">RTGS</option>
                  <option value="CHECK">CHECK</option>
                  <option value="DD">DD</option>
                  <option value="Cash">Cash</option>
                </select>
                <div class="text-danger" *ngIf="paidThrough.invalid && paidThrough.touched">
                  Payment method is required
                </div>
              </div>
              <div class="row" *ngIf="paymentdata.paidThrough !== 'Cash'">

                <!-- Bank Type -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">Bank Type</label>
                  <select class="form-select" [(ngModel)]="paymentdata.sBanktype"
                    (change)="bankTypeChange(paymentdata.sBanktype)" name="sBanktype">
                    <option value="0">Select Bank Type</option>
                    <option value="Nationalized">Nationalized</option>
                    <option value="Cooperative">Cooperative</option>
                  </select>
                </div>

                <!-- Bank Name -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">Bank Name</label>
                  <select class="form-select" name="bankName" [(ngModel)]="paymentdata.bankName"
                    (change)="onBankSelected()" required #bankName="ngModel">
                    <option value="0">Select Bank Name</option>
                    <option *ngFor="let item of bankList" [value]="item.bank">
                      {{ item.bank }}
                    </option>
                  </select>
                </div>

                <!-- Branch -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">Bank Branch</label>
                  <select class="form-select" [(ngModel)]="paymentdata.bankBranch" (change)="onBranchSelected()"
                    name="bankBranch">
                    <option value="0">Select Bank Branch</option>
                    <option *ngFor="let branch of branchList" [value]="branch.branchName">
                      {{ branch.branchName }}
                    </option>
                  </select>
                </div>

                <!-- IFSC -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">IFSC Code</label>
                  <input class="form-control" type="text" maxlength="15" placeholder="IFSC Code"
                    [(ngModel)]="paymentdata.iSFCCode" readonly name="iSFCCode">
                </div>



                <!-- Transaction No -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">Transaction No</label>
                  <input type="text" class="form-control" placeholder="Enter Transaction Number"
                    [(ngModel)]="paymentdata.transactionNo" name="transactionNo" required #transactionNo="ngModel" />
                  <div class="text-danger" *ngIf="transactionNo.invalid && transactionNo.touched">
                    Transaction number is required
                  </div>
                </div>

              </div>

              <!-- Upload Receipt -->
              <div class="col-md-6 mb-3">
                <label class="form-label" for="UploadReceipt">Upload Receipt</label>
                <input type="file" class="form-control" (change)="onFileChange($event)"
                  [(ngModel)]="paymentdata.uploadedFilePath" required #uploadReceipt="ngModel" />
                <small class="form-text text-muted">
                  Type: PDF | Max size: 2 MB
                </small>
                <div class="text-danger" *ngIf="uploadReceipt.touched">
                  Receipt is required
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
            <button type="submit" class="btn btn-primary" [disabled]="paymentForm.invalid">
              Add Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- Status Modal -->
  <div class="modal fade" id="AuditorStatus" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="AuditorStatusLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title" id="AuditorStatusLabel">
            <i class="bi bi-clock-history me-2"></i> Audit Status
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-3">
          <div class="card border shadow-sm">
            <div class="card-body p-3">
              <div class="step-progressbar">
                <div class="v-progress" style="max-height: 300px; overflow-y: auto">
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let process of filteredStatus" class="list-group-item">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong class="text-dark">{{
                            process.roleName
                            }}</strong>
                          <div class="text-muted small mt-1">
                            <strong class="text-danger">Action:</strong>
                            {{ process.remarks }}
                          </div>
                        </div>
                        <div class="text-end">
                          <span class="badge bg-light text-dark border">
                            <strong class="text-danger">Date:</strong>
                            {{ process.dCreateDate | date : "dd/MM/yyyy" }}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>